import React from 'react';
import './Constats.css';
import { FaBrain, FaHeartbeat, FaBed, FaUserMd, FaUsers, FaChartPie, FaTint, FaMoon, FaHeartBroken, FaThermometerHalf } from 'react-icons/fa';

const Constats = () => {
  const constatsData = [
    {
      id: 1,
      category: "Épuisement & Dépression",
      items: [
        { id: 1, label: "Détresse psychologique", value: "53%", icon: <FaBrain />, color: "#dc143c" },
        { id: 2, label: "Déprimes", value: "67%", icon: <FaHeartBroken />, color: "#ff3855" },
        { id: 3, label: "Épuisement", value: "60%", icon: <FaThermometerHalf />, color: "#ff6b6b" }
      ]
    },
    {
      id: 2,
      category: "Stress & Anxiété",
      items: [
        { id: 4, label: "Nervosité", value: "49%", icon: <FaHeartbeat />, color: "#1e3c72" },
        { id: 5, label: "Stress déclaré", value: "53%", icon: <FaChartPie />, color: "#2a5298" },
        { id: 6, label: "Tristesse et abattement", value: "38%", icon: <FaTint />, color: "#3a5f8a" }
      ]
    },
    {
      id: 3,
      category: "Solitude & Isolement",
      items: [
        { id: 7, label: "Solitude", value: "46%", icon: <FaUsers />, color: "#ff8c00" },
        { id: 8, label: "Isolement", value: "20%", icon: <FaUsers />, color: "#ffa500" },
        { id: 9, label: "Découragement", value: "24%", icon: <FaMoon />, color: "#ffd700" }
      ]
    },
    {
      id: 4,
      category: "Santé & Accès aux soins",
      items: [
        { id: 10, label: "Problème de sommeil", value: "39%", icon: <FaBed />, color: "#2e8b57" },
        { id: 11, label: "Mutuelle étudiante", value: "33%", icon: <FaUserMd />, color: "#3cb371" },
        { id: 12, label: "Renoncement à consulter", value: "25%", icon: <FaUserMd />, color: "#48d1cc" }
      ]
    }
  ];

  return (
    <section className="constats-section" id="etat-mental">
      <div className="constats-background">
        <div className="constats-glow constats-glow-1"></div>
        <div className="constats-glow constats-glow-2"></div>
        <div className="constats-pattern"></div>
      </div>

      <div className="constats-container">
        {/* Header */}
        <div className="constats-header">
          <h2 className="constats-main-title">
            Constats de l'état mental des étudiants étrangers
            <span className="constats-title-underline"></span>
          </h2>
          <p className="constats-introduction">
            Les chiffres révélateurs des défis psychologiques auxquels sont confrontés 
            les étudiants étrangers durant leur parcours en France
          </p>
        </div>

        {/* Grid principale */}
        <div className="constats-grid">
          {constatsData.map((category) => (
            <div className="constats-category" key={category.id}>
              <div className="category-header">
                <h3 className="category-title">{category.category}</h3>
                <div className="category-decoration"></div>
              </div>
              
              <div className="constats-items">
                {category.items.map((item) => (
                  <div className="constat-item" key={item.id}>
                    <div className="constat-icon-wrapper" style={{ backgroundColor: `${item.color}15` }}>
                      <div className="constat-icon" style={{ color: item.color }}>
                        {item.icon}
                      </div>
                    </div>
                    
                    <div className="constat-content">
                      <div className="constat-value-wrapper">
                        <span className="constat-value" style={{ color: item.color }}>
                          {item.value}
                        </span>
                        <div className="constat-bar-container">
                          <div 
                            className="constat-bar" 
                            style={{ 
                              width: item.value,
                              background: `linear-gradient(90deg, ${item.color}, ${item.color}cc)`
                            }}
                          ></div>
                        </div>
                      </div>
                      
                      <p className="constat-label">{item.label}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Note d'analyse */}
        <div className="constats-analysis">
          <div className="analysis-content">
            <h4 className="analysis-title">Analyse des données</h4>
            <p className="analysis-text">
              Ces chiffres alarmants mettent en lumière l'urgence d'un accompagnement psychologique 
              adapté pour les étudiants étrangers. L'éloignement familial, les barrières culturelles 
              et linguistiques, ainsi que la pression académique contribuent significativement 
              à ces difficultés psychologiques.
            </p>
            
            <div className="analysis-highlights">
              <div className="highlight-item">
                <div className="highlight-dot" style={{ backgroundColor: '#dc143c' }}></div>
                <span>Près de 7 étudiants sur 10 déclarent souffrir de déprime</span>
              </div>
              <div className="highlight-item">
                <div className="highlight-dot" style={{ backgroundColor: '#1e3c72' }}></div>
                <span>Plus de la moitié ressent un stress important</span>
              </div>
              <div className="highlight-item">
                <div className="highlight-dot" style={{ backgroundColor: '#ff8c00' }}></div>
                <span>1 étudiant sur 2 se sent régulièrement seul</span>
              </div>
            </div>
          </div>
          
          <div className="analysis-image">
            <div className="image-placeholder">
              <div className="placeholder-content">
                <FaBrain className="placeholder-icon" />
                <span>Santé Mentale Étudiante</span>
              </div>
            </div>
          </div>
        </div>

     
      </div>
    </section>
  );
};

export default Constats;